import { IntlShape } from "react-intl";

export const translateActivity = (activity: string, intl: IntlShape) => {
	const translationExists = !!intl.messages[`PresenceActivity.${activity}`];

	return translationExists
		? intl.formatMessage({ id: `PresenceActivity.${activity}` })
		: activity;
};
